var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter } from '@angular/core';
import { ActivitySearchCriteria } from '../../../../../models/group-search';
import { AchooSliderComponent } from '../../../../core/achoo-slider/achoo-slider.component';
import { CommonConstant } from '../../../../app.constants';
import { ActivityFilter } from '../../../../../models/filter-search';
import { ObjectUtils } from '../../../../utils/object.utils';
var ActivityFiltersComponent = /** @class */ (function () {
    function ActivityFiltersComponent() {
        this.searchInfluencerByActivityEvent = new EventEmitter();
        this.clearActivityFilterEvent = new EventEmitter();
        this.hideActivityFilterEvent = new EventEmitter();
        this.activitySearchCriteria = new ActivitySearchCriteria();
        this.minReach = 0;
        this.maxReach = CommonConstant.MAX_REACH_FOLLOWER;
        this.minEngagement = 0;
        this.maxEngagement = CommonConstant.MAX_REACH_ENGAGEMENT;
        this.minImpact = 0;
        this.minFollower = 0;
        this.maxFollower = CommonConstant.MAX_REACH_FOLLOWER;
    }
    ActivityFiltersComponent.prototype.ngOnInit = function () {
        this.maxImpact = this.isActiveDiscoverFollower ? CommonConstant.NEW_MAX_IMPACT : CommonConstant.OLD_MAX_IMPACT;
    };
    ActivityFiltersComponent.prototype.searchInfluencerByActivity = function () {
        var formattedCriteria = this.getFormattedSearchCriteria(this.activitySearchCriteria);
        this.searchInfluencerByActivityEvent.emit(formattedCriteria);
    };
    ActivityFiltersComponent.prototype.resetActivityFilters = function () {
        this.resetActivityUI();
        // emit event clear
        this.clearActivityFilterEvent.emit(this.activitySearchCriteria);
    };
    ActivityFiltersComponent.prototype.resetActivityUI = function () {
        // reset criteria
        this.activitySearchCriteria.selectedFollower = undefined;
        this.activitySearchCriteria.selectedImpact = undefined;
        this.activitySearchCriteria.selectedReach = undefined;
        this.activitySearchCriteria.selectedEngagement = undefined;
        // reset slider element
        this.reachRangeSlider.resetSlider();
        this.reachRangeSlider.sliderElement.reset();
        this.impactRangeSlider.resetSlider();
        this.impactRangeSlider.sliderElement.reset();
        if (this.isActiveDiscoverFollower) {
            this.followerRangeSlider.resetSlider();
            this.followerRangeSlider.sliderElement.reset();
        }
        else {
            this.engagementRangeSlider.resetSlider();
            this.engagementRangeSlider.sliderElement.reset();
        }
    };
    ActivityFiltersComponent.prototype.updateActivityUI = function (reachFrom, reachTo, secondFilterFrom, secondFilterTo, impactFrom, impactTo) {
        this.reachRangeSlider.updateRangeValue(reachFrom, reachTo);
        if (this.isActiveDiscoverFollower) {
            this.followerRangeSlider.updateRangeValue(secondFilterFrom, secondFilterTo);
        }
        else {
            this.engagementRangeSlider.updateRangeValue(secondFilterFrom, secondFilterTo);
        }
        this.impactRangeSlider.updateRangeValue(impactFrom, impactTo);
    };
    ActivityFiltersComponent.prototype.onClickedOutside = function (e) {
        var formattedCriteria = this.getFormattedSearchCriteria(this.activitySearchCriteria);
        this.hideActivityFilterEvent.emit(formattedCriteria);
    };
    Object.defineProperty(ActivityFiltersComponent.prototype, "reachFrom", {
        get: function () {
            return this.filter && this.filter.reachFrom > 0 ? this.filter.reachFrom : this.minReach;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivityFiltersComponent.prototype, "reachTo", {
        get: function () {
            return this.filter && this.filter.reachTo > 0 ? this.filter.reachTo : this.maxReach;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivityFiltersComponent.prototype, "engagementFrom", {
        get: function () {
            return this.filter && this.filter.engagementFrom > 0 ? this.filter.engagementFrom : this.minEngagement;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivityFiltersComponent.prototype, "engagementTo", {
        get: function () {
            return this.filter && this.filter.engagementTo > 0 ? this.filter.engagementTo : this.maxEngagement;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivityFiltersComponent.prototype, "followerFrom", {
        get: function () {
            return this.filter && this.filter.followerFrom > 0 ? this.filter.followerFrom : this.minFollower;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivityFiltersComponent.prototype, "followerTo", {
        get: function () {
            return this.filter && this.filter.followerTo > 0 ? this.filter.followerTo : this.maxFollower;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivityFiltersComponent.prototype, "impactFrom", {
        get: function () {
            return this.filter && this.filter.impactFrom > 0 ? this.filter.impactFrom : this.minImpact;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivityFiltersComponent.prototype, "impactTo", {
        get: function () {
            return this.filter && this.filter.impactTo > 0 ? this.filter.impactTo : this.maxImpact;
        },
        enumerable: true,
        configurable: true
    });
    ActivityFiltersComponent.prototype.getFormattedSearchCriteria = function (searchCriteria) {
        var result = __assign({}, searchCriteria);
        // follower
        var selectedFollower = searchCriteria.selectedFollower;
        if (selectedFollower && selectedFollower.to === this.maxFollower) {
            result = __assign({}, result, { selectedFollower: {
                    from: selectedFollower.from,
                    to: null
                } });
        }
        // reach
        var selectedReach = searchCriteria.selectedReach;
        if (selectedReach && selectedReach.to === this.maxReach) {
            result = __assign({}, result, { selectedReach: {
                    from: selectedReach.from,
                    to: null
                } });
        }
        // impact
        var selectedImpact = searchCriteria.selectedImpact;
        if (selectedImpact && selectedImpact.to === this.maxImpact) {
            result = __assign({}, result, { selectedImpact: {
                    from: selectedImpact.from,
                    to: null
                } });
        }
        // engagement
        var selectedEngagement = searchCriteria.selectedEngagement;
        if (selectedEngagement && selectedEngagement.to === this.maxEngagement) {
            result = __assign({}, result, { selectedEngagement: {
                    from: selectedEngagement.from,
                    to: null
                } });
        }
        return ObjectUtils.deepClone(result);
    };
    return ActivityFiltersComponent;
}());
export { ActivityFiltersComponent };



// WEBPACK FOOTER //
// ./src/app/main/group-details/search-bar/activity-filters/activity-filters.component.ts.pre-build-optimizer.js